import { useEffect } from 'react'

import MiniLoader from 'ageas-react-component-miniloader'
import {
  DiscountCampaings,
  InsuredObjectsOutput,
} from '../../@types/RunPetisSimulation'
import { MainContainer } from '../../GlobalStyles'
import { useSimulatorStore } from '../../Stores/simulatorStore'
import { useCoveragesStore } from '../../Stores/useCoveragesStore'
import { useCreateProposalStore } from '../../Stores/useCreateProposalStore'
import { useGetQuotationStore } from '../../Stores/useGetQuotationStore'
import { useRequestQuotationStore } from '../../Stores/useRequestQuotationStore'
import { useResumeStore } from '../../Stores/useResumeStore'
import { useRunPetisSimulationStore } from '../../Stores/useRunPetisSimulationStore'
import { useWarningStore } from '../../Stores/warningStore'
import { REFERRALS } from '../../constants/referrals'
import { SESSION_STORAGE } from '../../constants/sessionStorage'
import { WARNING_BAR } from '../../constants/warningBar'
import { useRunPetisSimulation } from '../../hooks/api/runPetisSimulation/useRunPetisSimulation'
import { useLeadsInfo } from '../../hooks/api/LeadsInfo/useLeadsInfo'
import { useRunPetisSimulationPayload } from '../../hooks/api/runPetisSimulation/useRunPetisSimulationPayload'
import { useLeadsInfoPayload } from '../../hooks/api/LeadsInfo/useLeadsInfoPayload'
import { useErrorRequest } from '../../hooks/useErrorRequest'
import { t } from '../../i18n'
import { InsuredObjects } from './InsuredObjects'
import {
  ActionsHeader,
  Cell,
  Container,
  Header,
  NameHeader,
  Row,
  Table,
  TableContainer,
} from './styles'

type Props = {
  isLoadingRecalculate: boolean
  setLoading: (value: boolean) => void
}

export const SafeAnimalsPackageTable = ({
  isLoadingRecalculate,
  setLoading,
}: Props) => {
  const { handleErrorRequest } = useErrorRequest()
  const { setQuoteId, setIsFullStop, isFullStop, currentPack, typeOfPrice } =
    useSimulatorStore()
  const { setWarningOptions } = useWarningStore()
  const { isResume } = useResumeStore()
  const {
    runPetisSimulation,
    setRunPetisSimulation,
    setPacksCampaigns,
    setIsReferral,
    setIsReferralWarning,
    hasRunPetisUpdated,
    setHasRunPetisUpdated,
    enabledRunPetisRequest,
    setEnabledRunPetisRequest,
    setSelectedPackCampaign,
    packsCampaigns,
    previousPackCampaign,
    resetCampaigns,
  } = useRunPetisSimulationStore()
  const { runPetisSimulationPayload } = useRunPetisSimulationPayload()
  const { mutate: associateLead } = useLeadsInfo();
  const leadsInfoPayload = useLeadsInfoPayload()
  const { setHasCreatedProposal } = useCreateProposalStore()
  const { resetCoverages } = useCoveragesStore()
  const { requestQuotation } = useRequestQuotationStore()
  const { resetGetQuotation } = useGetQuotationStore()

  const { data, isFetching, isError, error, isSuccess, remove } =
    useRunPetisSimulation(runPetisSimulationPayload, enabledRunPetisRequest)

  const handleReferrals = () => {
    if (
      (runPetisSimulation?.runPetisSimulationResponse?.referrals || [])
        ?.length > 0 &&
      !isResume
    ) {
      setIsReferral(true)

      const outcomeTypeCode =
        runPetisSimulation?.runPetisSimulationResponse?.referrals?.map(
          (referral) => referral.outcomeTypeCode,
        )
      setIsReferralWarning((outcomeTypeCode || [])?.includes(REFERRALS.warning))

      if (
        runPetisSimulation?.runPetisSimulationResponse?.referrals?.filter(
          (item) => item?.outcomeTypeCode === REFERRALS.fullStop,
        )?.length
      ) {
        setIsFullStop(true)
      } else {
        setIsFullStop(false)
      }

      setWarningOptions({
        labelTypes: [],
        mode: WARNING_BAR.mode.hide,
        modal: false,
      })
    }
  }

  const setWithoutCampaign = () => {
    setSelectedPackCampaign(
      packsCampaigns?.find(
        (item) => item.coverages === null,
      ) as DiscountCampaings,
    )

    const campaignElement: any = document?.querySelector(
      '#campaign-selectdropText',
    )

    campaignElement!.value =
      packsCampaigns?.find((item) => item.coverages === null)?.additionalText ||
      ''
  }

  const setPreviousCampaign = () => {
    setSelectedPackCampaign(previousPackCampaign)

    const campaignElement: any = document?.querySelector(
      '#campaign-selectdropText',
    )

    campaignElement!.value = previousPackCampaign?.additionalText || ''
  }

  const handleCampaignChangePack = () => {
    const packsSelected = Object.values(currentPack)

    if (previousPackCampaign) {
      if (
        (
          packsCampaigns?.filter(
            (item) =>
              item.campaignId === previousPackCampaign?.campaignId &&
              item.collectionMethod ===
                previousPackCampaign?.collectionMethod &&
              (item.installmentCode || '')?.toUpperCase() ===
                typeOfPrice.toUpperCase() &&
              packsSelected.includes(item.packId || ''),
          ) || []
        )?.length
      ) {
        setPreviousCampaign()
      } else {
        setWithoutCampaign()
      }
    }
  }

  useEffect(() => {
    handleCampaignChangePack()
  }, [currentPack, typeOfPrice])

  useEffect(() => {
    if (isSuccess) {
      setRunPetisSimulation(data!)
      setPacksCampaigns(data.discountsCampaigns || [])
    }
  }, [isSuccess, data])

  useEffect(() => {
    if (
      (runPetisSimulation?.runPetisSimulationResponse?.referrals || [])
        ?.length > 0 &&
      !isFetching
    ) {
      handleReferrals()
    }
  }, [runPetisSimulation, isFetching])

  useEffect(() => {
    if (
      runPetisSimulation?.runPetisSimulationResponse?.referrals?.length === 0
    ) {
      setIsReferralWarning(false)
    }

    if (hasRunPetisUpdated && runPetisSimulation) {
      resetCoverages()
      setQuoteId(runPetisSimulation?.runPetisSimulationResponse?.quoteId || '')
      setPacksCampaigns(runPetisSimulation.discountsCampaigns || [])
      setHasRunPetisUpdated(false)
      if (leadsInfoPayload.leadId){
         associateLead(leadsInfoPayload)
      }
    }
  }, [
    runPetisSimulation,
    hasRunPetisUpdated,
    setHasRunPetisUpdated,
    setQuoteId,
  ])

  useEffect(() => {
    setLoading(isFetching)
  }, [isFetching, setLoading])

  useEffect(() => {
    if (isSuccess) {
      remove()
      const oldRpsQuoteId = sessionStorage.getItem(
        SESSION_STORAGE.oldRpsQuoteId,
      )

      if (
        oldRpsQuoteId !==
        runPetisSimulation?.runPetisSimulationResponse?.quoteId
      ) {
        setHasCreatedProposal(false)

        sessionStorage.setItem(
          SESSION_STORAGE.oldRpsQuoteId,
          data?.runPetisSimulationResponse?.quoteId ||
            runPetisSimulation?.runPetisSimulationResponse?.quoteId ||
            '',
        )
      }

      setEnabledRunPetisRequest(false)
    }
  }, [isSuccess, runPetisSimulation])

  useEffect(() => {
    if (isError) {
      handleErrorRequest({ error })
    }
  }, [error, handleErrorRequest, isError])

  useEffect(() => {
    if (enabledRunPetisRequest) {
      if (requestQuotation !== null) {
        resetGetQuotation()
      }

      resetCampaigns()
    }
  }, [enabledRunPetisRequest, requestQuotation])

  useEffect(() => {
    if ((requestQuotation?.quoteId || '')?.length) {
      setWarningOptions({
        type: WARNING_BAR.type.info,
        labelTypes: [
          t('general.infoChangedSimulationNumber', {
            newSimulationNumber: requestQuotation?.quoteId,
          }),
        ],
      })
    }
  }, [requestQuotation])

  useEffect(() => {
    const styleElement = document.createElement('style')

    const cssStyles = `
      .overflowInitial {
        overflow: initial !important;
      }
    `

    styleElement.innerHTML = cssStyles
    document.head.appendChild(styleElement)

    document.body.classList.add('overflowInitial')

    if ((document.getElementsByTagName('main') || [])?.length) {
      document.getElementsByTagName('main')[0].style.overflow = 'initial'
    }

    return () => {
      if ((document.getElementsByTagName('main') || [])?.length) {
        document.getElementsByTagName('main')[0].style.overflow = 'hidden'
      }
    }
  }, [])

  return (
    <Container isFullStop={isFullStop}>
      <MainContainer>
        <TableContainer>
          <Table>
            <thead>
              <Row>
                <NameHeader>{t('table.name')}</NameHeader>
                <Header>{t('table.birthday')}</Header>
                <Header>{t('table.pack')}</Header>
                <Header>{t('table.breed')}</Header>
                <ActionsHeader></ActionsHeader>
              </Row>
            </thead>
            <tbody>
              {isFetching && (
                <Row>
                  <Cell colSpan={5}>
                    <MiniLoader
                      color="white"
                      minHeight="auto"
                      maxWidth="auto"
                    />
                  </Cell>
                </Row>
              )}
              {!isLoadingRecalculate && (
                <>
                  {!isFetching &&
                    runPetisSimulation?.runPetisSimulationResponse
                      ?.insuredObjectGroup?.insuredObjects &&
                    runPetisSimulation?.runPetisSimulationResponse?.insuredObjectGroup?.insuredObjects?.map(
                      (item: InsuredObjectsOutput, index: number) => (
                        <InsuredObjects
                          key={index}
                          data={item}
                          index={index}
                          sequence={item.insuredObjectSequence || 0}
                        />
                      ),
                    )}
                </>
              )}
            </tbody>
          </Table>
        </TableContainer>
      </MainContainer>
    </Container>
  )
}
